import React, { useState } from 'react';
import { auth } from '../firebase';
import { signOut } from 'firebase/auth';
import { toastManager } from '../utils/toastManager';
import { Menu, User, Settings, LogOut, ChevronDown } from 'lucide-react';
import './TopBar.css';

const TopBar = ({ onMenuToggle }) => {
  const [showUserMenu, setShowUserMenu] = useState(false);
  const user = auth.currentUser;

  return (
    <header className="top-bar">
      <div className="top-bar-left">
        <button className="mobile-menu-toggle" onClick={onMenuToggle} aria-label="Toggle menu">
          <Menu size={20} />
        </button>
      </div>

      <div className="top-bar-right">
        <div className="top-bar-user-menu">
          <button 
            className="top-bar-user-btn"
            onClick={() => setShowUserMenu(!showUserMenu)}
          >
            <div className="user-avatar-small">
              {user?.email?.charAt(0).toUpperCase() || 'U'}
            </div>
            <span className="user-name-short">
              {user?.displayName || user?.email?.split('@')[0] || 'User'}
            </span>
            <ChevronDown className="dropdown-arrow" size={14} />
          </button>

          {showUserMenu && (
            <div className="user-dropdown">
              <div className="user-dropdown-header">
                <div className="user-avatar-medium">
                  {user?.email?.charAt(0).toUpperCase() || 'U'}
                </div>
                <div className="user-dropdown-info">
                  <div className="user-dropdown-name">
                    {user?.displayName || 'User'}
                  </div>
                  <div className="user-dropdown-email">{user?.email}</div>
                </div>
              </div>
              <div className="user-dropdown-divider"></div>
              <button className="user-dropdown-item">
                <User className="icon" size={16} />
                <span>Profile</span>
              </button>
              <button className="user-dropdown-item">
                <Settings className="icon" size={16} />
                <span>Settings</span>
              </button>
              <div className="user-dropdown-divider"></div>
              <button 
                className="user-dropdown-item logout-item"
                onClick={async () => {
                  try {
                    await signOut(auth);
                    toastManager.success('Logged out successfully');
                    setShowUserMenu(false);
                  } catch (error) {
                    toastManager.error('Error signing out');
                  }
                }}
              >
                <LogOut className="icon" size={16} />
                <span>Logout</span>
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default TopBar;
